export default {"src":"/_next/static/media/maaran_color_logo.290c68a6.svg","height":188,"width":188,"blurWidth":0,"blurHeight":0};